module.exports = __webpack_public_path__ + "img/img_home_bg.aa667a23.png";